// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"a6028ad5","239":"dfdb0d71","453":"d855a71b"}[chunkId] + ".chunk.js";
};